<script>
    import { Route, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import PosEntries from './pos-entries.svelte'
    import PosBudgets from './pos-budgets.svelte'
    import Ztab from '../_common/z/ztab.svelte'
    import QuotationEntries from './quotation/quotation-entries.svelte'
    import { onMount } from 'svelte'
    import QuotationPrint from './quotation/quotation-print.svelte'
    import TaxEntries from './taxes/tax-entries.svelte'

    let tabs = []
    tabs.push({ title: 'Caixa', url: '/pos/entries' })

    onMount(async () => {
        if (window.configs.quotationVersionLatest || window.configs.quotationVersionLatest === undefined) {
            tabs.push({ title: 'Orçamentos', url: '/pos/quotes' })
        } else {
            tabs.push({ title: 'Orçamentos', url: '/pos/budgets' })
        }
        if (window.store.token.permissions.pos.taxInvoices?.read) {
            tabs.push({ title: 'Nota Fiscal', url: '/pos/taxes' })
        }
        tabs = tabs
    })
</script>

<div class="root-content">
    <Ztab class="h-space" {tabs} />
    <div class="body">
        <Router>
            <Route path="/entries">
                <PosEntries />
            </Route>
            <Route path="/budgets">
                <PosBudgets />
            </Route>
            <Route path="/quotes">
                <QuotationEntries></QuotationEntries>
            </Route>
            <Route path="/taxes">
                <TaxEntries></TaxEntries>
            </Route>
            <Route path="/print">
                <QuotationPrint></QuotationPrint>
            </Route>
        </Router>
    </div>
</div>
